module.exports = __webpack_public_path__ + "img/8.791c1516.jpg";